import DocumentUpload from '../document_upload';

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-white min-h-screen">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center px-4 sm:px-6 lg:px-20 py-16 relative z-10">
        {/* Left: Text Content */}
        <div className="w-full md:w-1/2 pr-0 md:pr-8">
          <h1
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 700,
              fontSize: 36,
              lineHeight: '44px', // Reduced from 64px to 44px
              letterSpacing: '-0px',
              color: '#000',
              marginBottom: '15px',
            }}
          >
            Agentic AI for
            <br />
            Data–to–Deployment
          </h1>
          <p
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 400,
              fontSize: 16,
              lineHeight: '32px',
              color: 'rgba(2,7,62,1)',
              maxWidth: 540,
              marginTop: 0,
              marginBottom: 0,
            }}
          >
            Built for organizations that want to transform raw, siloed data into actionable insights and deploy them as interactive, shareable platforms—autonomously and efficiently.
          </p>
        </div>

        {/* Right: File Upload Component */}
        <div className="w-full md:w-1/2 mt-12 md:mt-0 flex justify-center">
          <div className="w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden">
            <DocumentUpload />
          </div>
        </div>
      </div>
    </section>
  );
}